import React from 'react';
import { Heart, Sparkles } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="sobre" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">Quem Sou Eu</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_6ecc521e-0167-467f-95d1-01468e73454b/artifacts/67wpiicc_Imagem1.jpg"
                  alt="Gizeli Rodrigues - Terapeuta"
                  className="w-full h-full object-cover"
                  loading="eager"
                  style={{ imageRendering: 'high-quality' }}
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-2xl shadow-xl max-w-xs">
                <div className="flex items-center gap-2 mb-2">
                  <Sparkles size={20} />
                  <span className="font-semibold">Transformação Real</span>
                </div>
                <p className="text-sm text-blue-100">20 anos dedicados ao cuidado e bem-estar</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 p-3 rounded-full mt-1">
                  <Heart className="text-blue-600" size={24} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-blue-900 mb-4">Gizeli Rodrigues</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Sou esposa, mãe e mulher que há 20 anos transforma autoestima através da beleza. 
                    Minha história começou nos cabelos, ouvindo histórias enquanto devolvia brilho aos 
                    fios e confiança aos olhares. Mas, com o tempo, entendi que por trás da aparência 
                    existiam dores profundas, traumas não resolvidos e bloqueios invisíveis que não se 
                    curam com espelho.
                  </p>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed">
                Foi então que mergulhei na terapia emocional profunda — uma jornada de reencontro com 
                a mente e com a essência. Hoje, como terapeuta, ajudo pessoas a se libertarem do que as 
                prende emocionalmente: padrões inconscientes, traumas antigos, medos silenciosos.
              </p>

              <p className="text-gray-700 leading-relaxed">
                Minha missão é clara: unir técnica, sensibilidade e verdade para conduzir você a uma 
                transformação real — intensa, consciente e definitiva.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
                <p className="text-gray-800 leading-relaxed italic">
                  Se você sente que já fez muito por fora, mas ainda falta algo por dentro, eu estou 
                  aqui para guiar esse próximo passo.
                </p>
                <p className="text-gray-800 leading-relaxed italic mt-4 font-semibold">
                  Porque a verdadeira beleza nasce quando a mente encontra paz e o coração se reconhece.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;